import { Injectable } from '@angular/core';
import { Chooser } from '@ionic-native/chooser';


@Injectable()

export class FileService {

  public maxFileSizeMegaBytes = 8;

  constructor(
    public chooser: Chooser
  ) {}

  getFile() {
    return new Promise((resolve, reject) => {
      this.chooser.getFile('*').then(file => {
        if(file && file.dataURI){
          if(this.allowFilesize(file.dataURI)){
            resolve({
              filename: file.name,
              src: file.dataURI
            });
          } else {
            reject(-1);
          }
        }
      }).catch((err: any) => {
        reject(0);
      });
    });
  }

  allowFilesize(base64string) {
    let mb = (base64string.length * (3/4)) / 1000000;
    if(mb > this.maxFileSizeMegaBytes){
      return false;
    }
    return true;
  }

}



// WEBPACK FOOTER //
// ./src/services/file.service.ts